import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=2f5b2fae&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=ts&"
export * from "./ItemList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=2f5b2fae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b2fae",
  null
  
)

export default component.exports